/* eslint-disable class-methods-use-this */
import React, {Component} from 'react';
import {Redirect} from 'react-router';
import TeamLoginForm from '../../common/login/login-form';
import {isAdminLoggedIn} from '../../../utils/tokenUtils';
import {teamLogin} from '../../../actions/login';
import {USER_TYPE_REP} from '../../../data/userTypes';

class TeamLoginPage extends Component {
  render() {
    if (isAdminLoggedIn()) {
      return <Redirect to="/team/my-profile"/>;
    }

    return (
      <div className="row">
        <div className="col-md-5 col-md-offset-1">
          <TeamLoginForm loginAction={teamLogin} type={USER_TYPE_REP}/>
        </div>
      </div>
    );
  }
}

export default TeamLoginPage;



// WEBPACK FOOTER //
// ./src/components/team/login/login-page.jsx